var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkGithubLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_686_1678)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0132 0C7.15833 0 0 7.33333 0 16.4057C0 23.6577 4.58659 29.7963 10.9494 31.969C11.7449 32.1323 12.0363 31.616 12.0363 31.1817C12.0363 30.8013 12.0101 29.4977 12.0101 28.1393C7.5556 29.1173 6.62799 26.1837 6.62799 26.1837C5.91212 24.2823 4.85143 23.7937 4.85143 23.7937C3.39348 22.7887 4.95763 22.7887 4.95763 22.7887C6.57489 22.8973 7.4235 24.4727 7.4235 24.4727C8.85491 26.9713 11.1615 26.2653 12.0894 25.8307C12.2218 24.7713 12.6463 24.038 13.097 23.6307C9.54422 23.2503 5.80625 21.838 5.80625 15.5363C5.80625 13.7437 6.44214 12.277 7.44973 11.1363C7.29075 10.729 6.73386 9.04467 7.60903 6.79033C7.60903 6.79033 8.96111 6.35567 12.0098 8.47433C13.315 8.11522 14.6611 7.93254 16.0132 7.931C17.3653 7.931 18.7436 8.12133 20.0164 8.47433C23.0654 6.35567 24.4175 6.79033 24.4175 6.79033C25.2926 9.04467 24.7354 10.729 24.5764 11.1363C25.6106 12.277 26.2202 13.7437 26.2202 15.5363C26.2202 21.838 22.4823 23.223 18.9029 23.6307C19.4864 24.1467 19.9898 25.1243 19.9898 26.6727C19.9898 28.8727 19.9636 30.6383 19.9636 31.1813C19.9636 31.616 20.2553 32.1323 21.0505 31.9693C27.4133 29.796 31.9999 23.6577 31.9999 16.4057C32.0261 7.33333 24.8416 0 16.0132 0Z",
    fill: "#24292F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_686_1678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGithubLogo);
export default __webpack_public_path__ + "static/media/dark-github-logo.5784bda14c3e76c744431fad3f52b7a2.svg";
export { ForwardRef as ReactComponent };